import { render } from "./TestCaseTable.vue?vue&type=template&id=7be8c256&scoped=true"
import script from "./TestCaseTable.vue?vue&type=script&lang=js"
export * from "./TestCaseTable.vue?vue&type=script&lang=js"

import "./TestCaseTable.vue?vue&type=style&index=0&id=7be8c256&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be8c256"]])

export default __exports__